

const { Component, RawHTML } = wp.element;
import { Button, Dropdown } from '@wordpress/components'
import { useState } from '@wordpress/element'


class PGcssBackgroundSize extends Component {
  render() {


    const {
      val,
      onChange,



    } = this.props;


    var args = {
      auto: { "label": "auto", "value": "auto" },
      cover: { "label": "Cover", "value": "cover" },
      contain: { "label": "Contain", "value": "contain" },
      custom: { "label": "Custom", "value": "custom" },
      inherit: { "label": "inherit", "value": "inherit" },
      initial: { "label": "initial", "value": "initial" },
      revert: { "label": "revert", "value": "revert" },
      unset: { "label": "unset", "value": "unset" },
    };



    return (
      <div>

        <Dropdown
          position="bottom"
          renderToggle={({ isOpen, onToggle }) => (
            <Button
              title="Background Repeat"

              onClick={onToggle}
              aria-expanded={isOpen}
            >
              <div className=" ">{val ? args[val].label : 'Select...'}</div>


            </Button>
          )}
          renderContent={() => <div className='w-32'>

            {Object.entries(args).map((args) => {

              var index = args[0]
              var x = args[1]
              return (

                <div className={'px-3 py-1 border-b block hover:bg-gray-400 cursor-pointer'} onClick={(ev) => {

                  onChange(x.value, 'backgroundSize');




                }}>

                  {!x.value && (

                    <div>Reset</div>

                  )}

                  {x.value && (

                    <>{x.label}</>

                  )}

                </div>

              )

            })}
          </div>}
        />



      </div>

    )
  }
}


export default PGcssBackgroundSize;